import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';

import {inject, Injectable} from "@angular/core";
import {GeolocationService} from "./geolocation.service";
import {Observable, of, switchMap} from "rxjs";
import {Location} from "@angular/common";

@Injectable({
    providedIn: 'root',
})
export class LocalizationGuard {

    constructor(private geolocationService: GeolocationService,
                private router: Router,
                private location: Location) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const url = this.location.path(false);
        return this.geolocationService.hasLocationPermission().pipe(
            switchMap(hasPermission => {
                if (!hasPermission) {
                    this.router.navigate(['/activateLocation'], {queryParams: {urlRedirect: url}})
                }
                return of(true);
            })
        );
    }

}

export const isLocationAllowed: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(LocalizationGuard).canActivate(next, state)
}
